import { getDecimalCount, subcurrencies } from '~/utils';

/**
 * These models are meant to be used in select() and will be changed overtime when store updates,
 *  thus they should not store any other values other than input obj. Put the values into store.
 * Also, to avoid possible overriding issues of functions and getters,
 *  follow the convention that adds a '_' prefix to properties of subclasses.
 * Plus, we should not put here functionalities similiar to divisionsSelector, because no cache support.
 *  although we could memorize methods here, because they are invalidated when model stales.
 *  For method memorize, ref https://github.com/medikoo/memoizee/blob/master/lib/methods.js
 */

// TODO some sort of ACL to help with rendering the app

export const exists = (x: any): boolean => !!x?.id;

class Base {
  [key: string]: any;

  constructor(...obj: any[]) {
    Object.assign(this, ...obj);
  }
}

export class OT extends Base {
  get priceDecimalCount() {
    if (!this.price || !this.price.step) return 0;
    return getDecimalCount(this.price.step);
  }

  get volumeDecimalCount() {
    if (!this.loading || !this.loading.qty) return 0;
    return getDecimalCount(this.loading.qty);
  }
}

export class Order extends OT {
  get currencies() {
    let r = [this.price];
    if (this.price.currencies) {
      r = r.concat(this.price.currencies);
    }
    return r;
  }

  get hascurrencies() {
    return this.currencies.length > 1;
  }

  getPriceObjByCur(cur?: string) {
    const notfound = {
      currency: 'n/a',
      unit: 'n/a',
      val: 0,
    };
    if (!cur) return notfound;
    return this.currencies.find((c: any) => c.currency === cur) || notfound;
  }
}
export class Product extends Base {
  get _desc() {
    let currencyCode = this.currency?.code;
    const currencyFactor = this.currency?.factor;
    if (currencyFactor !== 1) {
      currencyCode = subcurrencies[currencyCode];
    }
    const factor = this.unit?.factor;
    const desc = this.unit?.desc;
    const extra = factor && factor < 1 ? `${factor * 100}%` : '';
    return `${currencyCode}/${desc}${extra ? ` ${extra}` : ''}`;
  }

  getDesc(loadingId?: string, currency?: string) {
    let currencyCode = this.currency?.code;
    if (currency) currencyCode = currency;
    const currencyFactor = this.currency?.factor;
    if (currencyFactor !== 1) {
      currencyCode = subcurrencies[currencyCode];
    }

    const factor = this.unit?.factor;
    let desc = this.unit?.desc;
    if (loadingId && this.unit?.name === 'packaging') {
      const loading = this.loading.find((l: any) => l.id === loadingId);
      if (loading) desc = loading.packaging;
    }

    const extra = factor && factor < 1 ? `${factor * 100}%` : '';
    return currencyCode && desc
      ? `${currencyCode}/${desc}${extra ? ` ${extra}` : ''}`
      : '';
  }

  get _volumeUnit() {
    const factor = this.unit?.factor;
    const desc = this.loadingunit?.desc;
    const extra = factor && factor < 1 ? ` (${factor * 100}%)` : '';
    return `${desc}${extra}`;
  }

  _getVolume(entVolume?: number) {
    if (!entVolume) return 0;

    const factor = this.unit?.factor;
    return factor * entVolume || 0;
  }

  _getValue(price?: number, entVolume?: number, loadingId?: string) {
    if (!price || !entVolume) return 0;

    const unitrel = this.unit?.rel ?? 1;
    const loadingunitrel = this.loadingunit?.rel ?? 1;

    const volume = this._getVolume(entVolume);

    if (loadingId && this.unit?.name === 'packaging') {
      const loading = this.loading.find((l: any) => l.id === loadingId);
      if (loading)
        return (
          (price * volume * (loading.packing_load ?? 1)) /
          (loading.qty ?? 1) /
          this.currency.factor
        );
    }

    return (
      (price * volume * loadingunitrel) / unitrel / this.currency.factor || 0
    );
  }

  get _isVolumeUnitDifferent() {
    if (this.unit?.name === 'packaging') return false;
    return this.loadingunit?.name !== this.unit?.name;
  }
}
